import Abba from "services/Abba";
import entitlements from "./entitlements";
import { SUBSCRIBER_DATA_COOKIE_NAME } from "common/constants/Constants";
import GoogleTracking from "services/GoogleTracking";
import Cookie from "js-cookie";
import UserService from "services/User";

function getAbbaFields(overrides = {}) {
    const isLoggedIn = UserService.hasUserToken();

    if (!isLoggedIn) {
        return { subscriber: false, ...overrides };
    }

    try {
        const abbaFields = JSON.parse(Cookie.get(SUBSCRIBER_DATA_COOKIE_NAME));

        return { ...abbaFields, ...overrides };
    } catch (e) {
        return null;
    }
}

// Actions (must be name-spaced for reducer)
export const ABBA_SET_ABBA_CONFIG = "ABBA_SET_ABBA_CONFIG";

const DEFAULT_STATE = {
    config: {},
    isLoaded: false
};

// Reducer
export function abbaReducer(state = DEFAULT_STATE, action = {}) {
    switch (action.type) {
        case ABBA_SET_ABBA_CONFIG:
            return {
                config: action.config,
                isLoaded: true
            };
        default:
            return state;
    }
}

// Action Creators
export function setAbbaConfig(abbaConfig = {}) {
    return {
        type: ABBA_SET_ABBA_CONFIG,
        config: abbaConfig
    };
}

export function getAbbaConfig({ forceReset, overrides } = {}) {
    return (dispatch, getState) => {
        const {
            abba: {
                isLoaded
            }
        } = getState();

        if (!forceReset && isLoaded) {
            return Promise.resolve();
        }

        const abbaFields = getAbbaFields(overrides);
        const isLoggedIn = UserService.hasUserToken();

        if (forceReset || (isLoggedIn && !abbaFields)) {
            return dispatch(entitlements.getSubscriptions({ showAccounts: true, showRatePlans: true }))
                .then(() => {
                    // The cookie will have been set by the getSubscriptions call
                    return Abba.getConfig(getAbbaFields(overrides));
                })
                .then((abbaConfig) => {
                    GoogleTracking.exposeAbbaConfig(abbaConfig);
                    dispatch(setAbbaConfig(abbaConfig));
                });
        }

        return Abba.getConfig(abbaFields)
            .then((abbaConfig) => {
                GoogleTracking.exposeAbbaConfig(abbaConfig);
                dispatch(setAbbaConfig(abbaConfig));
            }).catch((error) => {
                if (error.message === "Feed targets was empty.") {
                    GoogleTracking.exposeAbbaConfig({});
                    dispatch(setAbbaConfig({}));
                }
            });
    };
}

export default {
    abbaReducer,
    setAbbaConfig,
    getAbbaConfig
};
